import { UIBrandedFareFeatureAvailability } from "@flights/types";
import { FC } from "react";
import { Color } from "@bookingcom/bui-react/components/Icon/Icon.types";
import {
  CheckmarkSelectedFillIcon,
  CloseCircleFillIcon,
  DollarCircleFillIcon
} from "@bookingcom/bui-assets-react/streamline/index.js";
import flights_apex_web_branded_fare_icons_only from "utils/experiments/apex/flights_apex_web_branded_fare_icons_only";
import flights_apex_web_bf_icons_v3 from "utils/experiments/apex/flights_apex_web_bf_icons_v3";
import useIsPostBookingRoute from "hooks/useIsPostBookingRoute";

const availabilityIcons: Record<UIBrandedFareFeatureAvailability, { color: Color; icon: FC }> = {
  INCLUDED: { color: "constructive", icon: CheckmarkSelectedFillIcon },
  SELLABLE: { color: "neutral", icon: DollarCircleFillIcon },
  NOT_INCLUDED: { color: "destructive", icon: CloseCircleFillIcon }
};

export default function useAvailabilityIcon(availability: UIBrandedFareFeatureAvailability) {
  const isPostBookingRoute = useIsPostBookingRoute();

  const showForBfIconsV3 =
    !isPostBookingRoute && availability === "INCLUDED" && !!flights_apex_web_bf_icons_v3.trackWithDefaultStage();
  const showAvailabilityIcon = showForBfIconsV3 || !!flights_apex_web_branded_fare_icons_only.trackWithDefaultStage();

  return showAvailabilityIcon ? availabilityIcons[availability] : undefined;
}
